(function () {
    'use strict';

    angular.module('ecap.crm', []);

})();